import React from "react";
import { PortalUserDeviceTemplate } from "themes/administration/analytics/components";

function PortalUserDevice(props) {
    return <PortalUserDeviceTemplate {...props} />;
}

export default PortalUserDevice;